import intlTelInput from 'intl-tel-input/intlTelInputWithUtils';

var phoneInput = function(element, options) {

    var _defaults = {
        countryOrder: ['us', 'gb', 'nl', 'de', 'fr', 'es', 'cz', 'ca']
    }

    var widget = this;

    widget.options = $.extend({}, _defaults, options || {});
    widget.input = element;
    widget.form = element.closest('form');

    widget._initialize();
    widget._bindEvents();

};

phoneInput.prototype._initialize = function() {
    var widget = this;
    widget.iti = intlTelInput(widget.input[0], widget.options);
};

phoneInput.prototype._bindEvents = function() {
    var widget = this;
    widget.form.submit(function(e) {
        widget.input.val(widget.iti.getNumber());
    });
};

export default phoneInput;